import "./whistleblowing.css";
import { Link } from "react-router-dom";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import whistleBanner from "../images/whistle-banner.jpg";
import mail from "../images/mail.png";
import web from "../images/web.png";
import toll from "../images/toll.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "./footer";
import AOS from 'aos';

const Whistle = () => {
  function buttonCall() {
    const target = document.getElementById("whistleContent");

    target.scrollIntoView({ behavior: "smooth" });
  }
  window.scrollTo(0, 0);

  return (
    <>
      <div className="mp-container">
        <div className="mp-cover">
          <img className="mp-bg" src={whistleBanner} />
          <div className="mp-content">
            <div id="whistle-text" className="abt-text-whistle mp-txt">
              <h1 className="mp-h1" data-aos="zoom-in" data-aos-delay="200">Whistleblowing</h1>
              <p className="grey-p-whistle" data-aos="fade-up" data-aos-delay="200">
                Report any misconduct safely and easily.
              </p>
              <a className="btn-trns" onClick={buttonCall} data-aos="fade-up" data-aos-delay="200">
                {" "}
                How to Report{" "}
                <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="white-cont padding-section-standard-top">
        <div
          id="mobile-view-whistle"
          className="containeer row d-flex justify-content-between text-center "
        >
          <div className="text-center pb-5">
            <h2 className="lead-h2 dark-text" id="whistleContent" >
              Three Ways to Report <br />
              Incidents
            </h2>
            <p className="grey-p-whistle dark-text-2">
              You may report incidents anonymously or choose to declare your
              identity.
            </p>
          </div>
          <div id="mobile-view" className="d-flex justify-content-between">
            <div className="card whistle-crd">
              <div className="text-start">
                <img className="pb-5" src={mail}  data-aos="fade-up" data-aos-delay="200"/>
                <h4 className="card-subtitle mb-1 statements-hdr" data-aos="fade-up" data-aos-delay="200">Email</h4>
                <p className="card-text pt-3 grey-p-whistle" data-aos="fade-up" data-aos-delay="200">
                  Whistleblowing.hotmail@iodccg.com{" "}
                </p>

                <a
                  class=" open-acc-btn-whistle  grey-p mt-3"
                  href="mailto:Whistleblowing.hotmail@iodccg.com"
                  role="button"
                  data-aos="fade-up" data-aos-delay="200"
                
                >
                  Send Email{" "}
                  <FontAwesomeIcon
                    className="chv-dwn--footer"
                    icon={faArrowRight}
                  />
                </a>
              </div>
            </div>

            <div className="card whistle-crd">
              <div className="text-start">
                <img className="pb-5" src={toll} data-aos="fade-up" data-aos-delay="200" />
                <h4 className="card-subtitle mb-1 statements-hdr" data-aos="fade-up" data-aos-delay="200">
                  Toll Free Line
                </h4>
                <p className="card-text pt-3 grey-p-whistle" data-aos="fade-up" data-aos-delay="200">
                  080000REPORT / 080000737678{" "}
                </p>

                <a
                  class=" open-acc-btn-whistle  grey-p mt-3"
                  href="tel:+23480000737678"
                  role="button"
                  data-aos="fade-up" data-aos-delay="200"
                >
                  Call Now{" "}
                  <FontAwesomeIcon
                    className="chv-dwn--footer"
                    icon={faArrowRight}
                  />
                </a>
              </div>
            </div>

            <div className="card whistle-crd">
              <div className="text-start">
                <img className="pb-5" src={web} data-aos="fade-up" data-aos-delay="200" />
                <h4 className="card-subtitle mb-1 statements-hdr" data-aos="fade-up" data-aos-delay="200">
                  Web Portal
                </h4>
                <p className="card-text pt-3 grey-p-whistle" data-aos="fade-up" data-aos-delay="200">
                  https://iodccg.com/wb/.{" "}
                </p>

                <a
                  class=" open-acc-btn-whistle  grey-p mt-3"
                  href="https://iodccg.com/wb/"
                  role="button"
                  target="_blank"
                  data-aos="fade-up" data-aos-delay="200"
                
                >
                  Open Portal{" "}
                  <FontAwesomeIcon
                    className="chv-dwn--footer"
                    icon={faArrowRight}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
          <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Whistle;
